import React, { memo, useMemo } from 'react'
import { SHOW_INCLUDED_WARRANTY } from 'utils/vehicles'
import clsx from 'clsx'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Tile from 'components/shared/Tile'
import { FormattedMessage } from 'react-intl'
import Text, { TEXT_TYPES } from 'components/designSystem/Text'
import { formatStateToShortName } from 'utils/miscellaneous'
import GreenWallet from 'components/icons/green-wallet.svg'
import BlueFlame from 'components/icons/blue_flame.svg'
import { VDP_TYPE } from 'enums'
import LocationIcon from 'components/icons/location.svg'
import BranchIcon from 'components/icons/branchIcon.svg'
import sx from './styles'

const VehicleStatusAndLocation = (props) => {
  const {
    sx: sxProp = {},
    sxContainer = {},
    status = '',
    state = '',
    sellerName = '',
    hasDiscount = false,
    category,
    showLocation = true,
    endPromotionDate = null,
    creditText = '',
    watchingText = '',
    showStatus = false,
    branch = {},
    vehicleType = VDP_TYPE.CLIKAUTO,
    // variant,
    variantWatching = 'normal', // normal|fill
    // isB2BVehicle,
    // holdingType,
    isProximo = false,
    showWarrantyTag = false,
    showOneYearWarranty = false,
    showThreeMonthWarranty = false,
  } = props
  const stateName = vehicleType === VDP_TYPE.PARTICULAR ? branch?.state : state

  // console.log('showWarrantyTag:', showWarrantyTag)
  // console.log('isB2BVehicle:', isB2BVehicle)
  // console.log('validation:', showWarrantyTag || ((variant === '1' || variant === '3')
  // && (vehicleType === VDP_TYPE.CLIKAUTO || vehicleType === VDP_TYPE.PROXIMO) && !isB2BVehicle))

  const items = useMemo(() => [
    {
      text: status ? <FormattedMessage id={`VEHICLE_STATUS_${status}`} /> : '',
      type: 'status',
      status_name: status,
      visible: !!status && showStatus,
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.quote}
          sx={sx.quote}
        >
          <FormattedMessage id="VEHICLE_STATUS_COMMING_SOON" />
        </Text>),
      bgColor: '#135FC4',
      visible: vehicleType === VDP_TYPE.PROXIMO || isProximo,
      order: 1,
      type: 'proximo',
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.quote}
          sx={sx.quote}
        >
          <FormattedMessage id="VEHICLE_STATUS_ONE_YEAR" />
        </Text>),
      type: 'status',
      status_name: 'ONE_YEAR',
      // visible: (variant === '1' || variant === '3') && (vehicleType === VDP_TYPE.CLIKAUTO
      // || vehicleType === VDP_TYPE.PROXIMO) && !isB2BVehicle,
      // Oculta por el interruptor de menciones de garantía incluida.
      visible: SHOW_INCLUDED_WARRANTY && showOneYearWarranty,
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.quote}
          sx={sx.quote}
        >
          <FormattedMessage id="VEHICLE_STATUS_THREE_MONTHS" />
        </Text>),
      type: 'status',
      status_name: 'ONE_YEAR',
      // visible: (variant === '1' || variant === '3') && (vehicleType === VDP_TYPE.CLIKAUTO
      // || vehicleType === VDP_TYPE.PROXIMO) && !isB2BVehicle,
      // Oculta por el interruptor de menciones de garantía incluida.
      visible: SHOW_INCLUDED_WARRANTY && showThreeMonthWarranty,
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.quote}
          sx={sx.quote}
        >
          <FormattedMessage id="VEHICLE_STATUS_GO_BACK" />
        </Text>),
      type: 'status',
      status_name: 'GO_BACK',
      // visible: (variant === '2' || variant === '3') && (vehicleType === VDP_TYPE.CLIKAUTO
      // || vehicleType === VDP_TYPE.PROXIMO) && !isB2BVehicle,
      visible: showWarrantyTag,
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.strong}
          sx={sx.peopleAction('success.dark')}

        >
          {creditText}
        </Text>
      ),
      type: 'waching',
      icon: <GreenWallet />,
      visible: creditText.length > 0 && vehicleType !== VDP_TYPE.CLIKAUTO,
    },
    {
      text: (
        <Text
          type={TEXT_TYPES.strong}
          sx={sx.peopleAction('text.blue')}

        >
          {watchingText}
        </Text>
      ),
      type: 'waching',
      icon: <BlueFlame />,
      // visible: watchingText.length > 0 && vehicleType !== VDP_TYPE.CLIKAUTO,
      visible: false,
    },
    {
      text: formatStateToShortName(stateName),
      icon: <LocationIcon />,
      visible: showLocation && stateName,
    },
    {
      text: sellerName,
      icon: <BranchIcon />,
      visible: false,
      // visible: consignaExist && !isSrp,
    },
  ], [status, category, hasDiscount, endPromotionDate,
    creditText, watchingText, showLocation, state, sellerName])

  return (
    <Box
      sx={{ ...sxContainer }}
      className="Vehicle-Status-root"
    >
      <Grid
        sx={{ ...sx.root, ...sxProp }}
        className="Container-root"
        container
        alignItems="center"
        spacing={1}
      >
        {items
          .filter((i) => i.visible)
          .map((item, index) => (
            <Grid
              key={`status-item-${index}`}
              className="Tile-item"
              size="grow"
            >
              <Tile
                sx={sx.tile}
                className={clsx('dense', {
                  promotion: item.type === 'promotion',
                  status_hold: item.type === 'status' && item.status_name === 'HOLD',
                  status_hold_online: item.type === 'status' && item.status_name === 'HOLD_ONLINE',
                  status_available: item.type === 'status' && item.status_name === 'AVAILABLE',
                  status_archived: item.type === 'status' && item.status_name === 'ARCHIVED',
                  status_discount: item.type === 'status' && item.status_name === 'WITH_DISCOUNT',
                  status_discountyear: (item.type === 'status' && item.status_name === 'ONE_YEAR'),
                  status_discountGoBack: (item.type === 'status' && item.status_name === 'GO_BACK'),
                  status_hotsale: item.type === 'hotsale',
                  status_proximo: item.type === 'proximo',
                  consignacion: item.type === 'consignacion',
                  greenBG: item.type === 'waching' && variantWatching === 'fill',
                  colorBlack: item?.status_name === 'GO_BACK',
                })}
                text={item.text}
                icon={item?.icon}
                variant="row"
              />
            </Grid>
          ))}
      </Grid>
    </Box>
  )
}

export default memo(VehicleStatusAndLocation)
